<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="2" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        title:'Halcyon新世代環形治療系統',
        videosrc:'T04.mp4',

        list:[
          {
            body:"Halcyon簡單、高效率且精準，讓患者和工作人員更放心同時提供高標準癌症照護。憑藉著Varian Halcyon，將影像導航技術納入治療流程，同時透過最新疊代式影像導航放射治療iCBCT的高品質，同時縮短治療時間為傳統的一半，提供高品質、簡易操作並且患者為中心的出發點進行放射治療環境的優化及改善。為每一位合適的患者和世界各地的癌症照護提供優質的品質。<br><br>我們重新思考放射治療執行的方式，與您一同對抗癌症的方式。我們考慮了所有可能性和不可能性，以設計一個以患者為中心的放射治療平台，專注於高品質癌症照護。此尖端的放射治療系統，符合人體工程學設計，為臨床工作人員和患者提供直觀、友好和舒適的體驗。這種以人為本的方法代表著工作人員需要擔心的部分和妥協更少，可以騰出更多時間來提高臨床照護品質，最重要的是，有更多機會為每位患者提供最高水平的癌症照護。"

          }

        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
